import React, { useState, useRef, KeyboardEventHandler } from "react";
// https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
// https://clerk.com/blog/setting-and-using-cookies-in-react
//import { CookiesProvider, useCookies } from 'react-cookies'

import { AdList } from './AdList'

import snabbletaLogo from '../assets/images/snabbleta.png'

import enhundringLogo from '../assets/images/enhundring-logo.png'
import enlaxLogo from '../assets/images/enlax-logo.png'
import crossjaktLogo from '../assets/images/crossjakt-logo.png'

import search from '../assets/images/search.png'

import enhundringIcon from '../assets/images/enhundring-icon-192.png'
import enlaxIcon from '../assets/images/enlax-icon-192.png'
import crossjaktIcon from '../assets/images/crossjakt-icon-192.png'

import "./AdStyles.css";



export function AdPage() {
    const locationFieldRef = useRef<null | HTMLInputElement>(null);

    const [debugRefresh, setDebugRefresh] = useState(false)

    const [mainCategory, setMainCategory] = useState("")

    const [myLocation, setMyLocation] = useState("")
    const [tempLocation, setTempLocation] = useState(myLocation); // Temporary state

    const [searchCriteria, setSearchCriteria] = useState("");
    const [tempSearchCriteria, setTempSearchCriteria] = useState(searchCriteria); // Temporary state

    const [sortBy, setSortBy] = useState("latest");

    const [refreshAt, setRefreshAt] = useState<Date>(new Date());

    const [requestCloseAllItemsAt, setRequestCloseAllItemsAt] = useState<Date>(new Date());

    let icon = enhundringIcon;
    switch (mainCategory) {
        case "lax":
            icon = enlaxIcon;
            break;

        case "cross":
            icon = crossjaktIcon;
            break;
    }

    const doReRender = () => {
        setDebugRefresh(!debugRefresh);
    }

    const locationFieldKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key == "Enter") {
            //const location = e.currentTarget.value;
            //setMyLocation(location);
            e.currentTarget.blur();
        }
    }

    const locationFieldBlur = () => {
        setMyLocation(tempLocation); // Update the final state when textbox loses focus
        scrollToTop();
    };

    const callbackFromToolbar = (command: string) => {
        console.log("callback from toolbar: " + command);

        switch (command) {
            case "refresh":
                doReRender();
                break;
        }
    }

    const refreshCB = () => {
        setRefreshAt(new Date());
    }

    const searchCB = (criteria: string) => {
        setSearchCriteria(criteria);
        scrollToTop();
    }

    const sortByLatestCB = () => {
        setSortBy("latest");
        scrollToTop();
    }

    const sortByCheapestCB = () => {
        setSortBy("cheapest");
        scrollToTop();
    }

    const sortByClosestCB = () => {
        setSortBy("closest");
        scrollToTop();
    }

    const closeAllItemsCB = () => {
        setRequestCloseAllItemsAt(new Date());
    }

    const reloadPage = (mainCategory: string) => {
        setSearchCriteria("");
        setTempSearchCriteria("");
        setMainCategory(mainCategory);
        //window.location.reload();
    }

    const searchFieldRef = useRef<null | HTMLInputElement>(null);

    const searchFieldKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode == 13) {
            //setSearchCriteria(tempSearchCriteria);
            //const criteria = e.currentTarget.value;
            searchCB(tempSearchCriteria);
            e.currentTarget.blur();
        }
    }

    const scrollToTop = () => {
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    }

    const iconClick = () => {
        //if (searchFieldRef?.current) {
        //    searchFieldRef.current.value = "";
        //}
        //searchCB("");
        closeAllItemsCB();
        //refreshCB();
        scrollToTop();
    }

    let logo = enhundringLogo;
    let pageName = "enhundring.se";
    let sloganText = "- saker som kostar en hundring";
    let pageBackColor = "lightskyblue"
    let darkBackColor = "#7ac8fa";

    switch (mainCategory) {
        default:
        case "hundring":
            pageBackColor = "lightskyblue";
            darkBackColor = "#7ac8fa";
            logo = enhundringLogo;
            pageName = "enhundring.se";
            sloganText = "- saker som kostar en hundring";
            break;

        case "lax":
            pageBackColor = "mistyrose";
            darkBackColor = "lightsalmon";
            logo = enlaxLogo;
            pageName = "enlax.se";
            sloganText = "- saker som kostar en lax";
            break;

        case "cross":
            pageBackColor = "#333333";
            darkBackColor = "#222222";
            logo = crossjaktLogo;
            pageName = "crossjakt";
            sloganText = "- en del av crossportalen.se";
            break;
    }

    document.body.style.backgroundColor = pageBackColor;

    let sectionIcon;
    if (mainCategory !== "") {
        sectionIcon = <img style={{ height: "3em", marginRight: "1em", cursor: "pointer" }} src={icon} onClick={iconClick} alt={pageName} />
    }

    let btnBilligast;
    if (mainCategory !== "hundring" && mainCategory != "lax") {
        btnBilligast = <div className="QuickButton" onClick={sortByCheapestCB} style={{ fontWeight: sortBy === "cheapest" ? "bold" : "" }}>Billigast</div>
    }

    let innerItem = null;

    if (mainCategory !== "") {
        innerItem =
            (<div style={{ textAlign: "center", padding: "0.0em" }} >
                <div className="Toolbar" style={{
                    display: "flex", alignItems: "center", justifyContent: "center",
                    height: "4em",
                    paddingBottom: "0.5em", backgroundColor: pageBackColor
                }} >
                    {/*<img src={logo} className="AppLogo" alt={pageName} onClick={() => reloadPage(mainCategory)} />*/}
                    {/*<div className="AppSloganBox">*/}
                    {/*    <span style={{ display: "inline-block", marginBottom: "1em", fontWeight: "bold" }} >V&auml;lkommen till {pageName}</span><br />*/}
                    {/*    <span style={{ fontStyle: "italic" }} >{sloganText}</span>*/}
                    {/*</div>*/}
                    {sectionIcon}
                    <div className="QuickButton">
                        <img src={search} className="SearchImage" /><input type="text" value={tempSearchCriteria} className="SearchField" ref={searchFieldRef} onKeyDown={searchFieldKeyPress} onChange={(e) => setTempSearchCriteria(e.target.value)} />
                    </div>
                    <div className="QuickButton" onClick={sortByLatestCB} style={{ fontWeight: sortBy === "latest" ? "bold" : "" }} >Senast</div>
                    {btnBilligast}
                    <div className="QuickButton" onClick={sortByClosestCB} style={{ fontWeight: sortBy === "closest" ? "bold" : "" }}>N&auml;rmast
                        <input type="text" value={tempLocation} placeholder="Ort eller postnr" style={{ width: "8em", fontSize: "100%", paddingTop: "2px", display: sortBy === "closest" ? "" : "none" }} onChange={(e) => setTempLocation(e.target.value)} onKeyPress={locationFieldKeyPress} onBlur={locationFieldBlur} className="SearchField" ref={locationFieldRef} />
                    </div>
                </div>
                {/*<AdToolbar category={mainCategory} pageBackColor={pageBackColor} refreshCB={refreshCB} searchCB={searchCB} closeAllItemsCB={closeAllItemsCB} />*/}
                <AdList category={mainCategory} darkBackColor={darkBackColor} searchCriteria={searchCriteria} searchNearLocation={myLocation} sortBy={sortBy} refreshAt={refreshAt} requestCloseAllItemsAt={requestCloseAllItemsAt} />
            </div>)
    }
    else {
        innerItem = (
            <div style={{ textAlign: "center" }}>
                <div className="AppSloganBox" onClick={() => reloadPage("hundring")}><img src={enhundringLogo} className="AppLogo" alt="Saker som kostar en hundring" /></div>
                <div className="AppSloganBox" onClick={() => reloadPage("lax")}><img src={enlaxLogo} className="AppLogo" alt="Saker som kostar en lax" /></div>
                <div className="AppSloganBox" onClick={() => reloadPage("cross")}><img src={crossjaktLogo} className="AppLogo" alt="Crossar" /></div>
            </div >)
    }

    return (<div>
        <div style={{ backgroundColor: pageBackColor, display: "flex", height: "3em", alignItems: "center", justifyContent: "center" }} >
            <img style={{ cursor: "pointer" }} src={snabbletaLogo} alt="snabbleta.se" onClick={() => reloadPage("")} />
        </div>
        {innerItem}
    </div>);
}
